import {
    IValidationRuleProvider,
} from "../../../../../../models/ValidationRuleModel";

const ValidationRules: IValidationRuleProvider = {};

export default ValidationRules;
